import { useCallback } from "react";
import { useTranslation } from "react-i18next";

// FAQ chrome i18n — the repo's static-bundle pattern (EN source text is the
// key, `static` namespace). Ticket 1 only prepares the strings; the 16-column
// bundle is registered in Ticket 2 (staticBundleCompleteness gate).
const useFaqT = () => {
  const { t } = useTranslation();
  return useCallback(
    (text, opts = {}) => t(text, { ns: "static", defaultValue: text, ...opts }),
    [t]
  );
};

export default useFaqT;
